import "./mega_menu";
import "./accordion";
import "./tooltip";
import "./stacked-table";
import "./search-suggestion";
import Chatlink from "./chatlink";
import muCarousel from "./muCarousel";
import MuSearchDesktop from "./MuSearchDesktop";
import MuSearchMobile from "./MuSearchMobile";

let chatlink = new Chatlink();
muCarousel();
MuSearchDesktop();
MuSearchMobile();